export const createRedirectPath = (
  pathname = '/',
  params: Record<string, string> = {},
) => {
  const searchParams = new URLSearchParams();

  Object.keys(params).forEach((key) => searchParams.set(key, params[key]));
  if (Array.from(searchParams.entries()).length === 0) {
    return `${window.location.origin}${pathname}`;
  }

  return `${window.location.origin}${pathname}?${searchParams.toString()}`;
};
